import { makeStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
  root: {
    '&:not(:last-child)': {
      marginBottom: '2.5rem',
    },
  },
  title: {
    fontSize: '2.5rem',
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.4,
  },
});

const Section = ({ title, disabled, ...props }) => {
  const classes = useStyles();
  return (
    <section
      className={
        disabled ? [classes.root, classes.disabled].join(' ') : classes.root
      }
    >
      {title && (
        <Typography
          className={classes.title}
          variant="h4"
          component="h2"
          gutterBottom
        >
          {title}
        </Typography>
      )}
      {props.children}
    </section>
  );
};

Section.defaultProps = {
  title: undefined,
  disabled: false,
};

Section.propTypes = {
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export default Section;
